import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

    subscribeToNewsletter(): void {
        window.location.href = 'https://best.org.mk/forma-za-apliciranje/';
    }

}
